// extracted by mini-css-extract-plugin
export var bodyRow = "_fi-d";
export var cardColumns = "_fi-e";
export var ellipsesOverflow = "_fi-2";
export var flatBottomCorners = "_fi-3";
export var flatTopCorners = "_fi-4";
export var headerActionsDropdown = "_fi-f";
export var headerBottomRow = "_fi-c";
export var headerTopRow = "_fi-b";
export var orderDetailsWrapper = "_fi-0";
export var orderInfoContainer = "_fi-1";
export var productDetails = "_fi-9";
export var productImage = "_fi-5";
export var responsiveTable = "_fi-8";
export var shipmentContainer = "_fi-a";
export var tableBottomLeft = "_fi-6";
export var tableBottomRight = "_fi-7";
export var trackingLink = "_fi-g";